// import React from "react";
// import { Label } from "../../../../Components/ui/label";
// import { Accordion } from "../../../../Components/ui/accordion";
// import CountryRoamingDaysAccordion from "../components/Countryroamingdaysaccordion";

// interface RoamingDaysSectionProps {
//   isViewMode: boolean;
//   roamingDaysByCountry: any;
//   setRoamingDaysByCountry: React.Dispatch<any>;
//   fromCountryISOs: Record<string, string>;
//   fromCountries: string[];
// }

// const RoamingDaysSection: React.FC<RoamingDaysSectionProps> = ({
//   isViewMode,
//   roamingDaysByCountry,
//   setRoamingDaysByCountry,
//   fromCountryISOs,
//   fromCountries,
// }) => {
//   if (!fromCountries || fromCountries.length === 0) return null;

//   const handleCountryUpdate = (
//     iso: string,
//     updatedConfig: {
//       condition_a: { con_operator: string; value: number };
//       condition_b: { con_operator: string; value: number } | null;
//     }
//   ) => {
//     setRoamingDaysByCountry({
//       ...roamingDaysByCountry,
//       [iso]: updatedConfig,
//     });
//   };

//   return (
//     <div className="mt-4">
//       <Label className="font-medium text-[#020617]" style={{ fontSize: "14px" }}>
//         Roaming Days
//       </Label>

//       <Accordion type="multiple" className="w-full mt-2">
//         {fromCountries.map((country) => {
//           const iso = fromCountryISOs[country];
//           if (!iso) return null;

//           const config = roamingDaysByCountry[iso];
//           if (!config) return null;

//           return (
//             <CountryRoamingDaysAccordion
//               key={iso}
//               countryName={country}
//               countryISO={iso}
//               roamingDayConfig={config}
//               onUpdate={handleCountryUpdate}
//               isViewMode={isViewMode}
//             />
//           );
//         })}
//       </Accordion>
//     </div>
//   );
// };

// export default RoamingDaysSection;

import React from "react";
import { Label } from "../../../../Components/ui/label";
import { Accordion } from "../../../../Components/ui/accordion"
import CountryRoamingDaysAccordion from "../components/Countryroamingdaysaccordion";

interface RoamingDaysSectionProps {
  isViewMode: boolean;
  roamingDaysByCountry: any;
  setRoamingDaysByCountry: React.Dispatch<any>;
  fromCountryISOs: Record<string, string>;
  fromCountries: string[];
}

const RoamingDaysSection: React.FC<RoamingDaysSectionProps> = ({
  isViewMode,
  roamingDaysByCountry,
  setRoamingDaysByCountry,
  fromCountryISOs,
  fromCountries,
}) => {
  if (!fromCountries || fromCountries.length === 0) return null;

  const handleCountryUpdate = (
    iso: string,
    updatedConfig: {
      condition_a: { con_operator: string; value: number };
      condition_b: { con_operator: string; value: number } | null;
    }
  ) => {
    setRoamingDaysByCountry({
      ...roamingDaysByCountry,
      [iso]: updatedConfig,
    });
  };

  return (
    <div className="mt-4">
      <Label className="font-medium text-[#020617]" style={{ fontSize: "14px" }}>
        Roaming Days
      </Label>

      <div className="mt-1 border rounded-md px-3 py-1">
        <Accordion type="multiple" className="w-full">
          {fromCountries.map((country) => {
            const iso = fromCountryISOs[country];
            if (!iso) return null;

            const config = roamingDaysByCountry[iso];
            if (!config) return null;

            return (
              <CountryRoamingDaysAccordion
                key={iso}
                countryName={country}
                countryISO={iso}
                roamingDayConfig={config}
                onUpdate={handleCountryUpdate}
                isViewMode={isViewMode}
              />
            );
          })}
        </Accordion>
      </div>
    </div>
  );
};

export default RoamingDaysSection;
